import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function ShoppingCartIcon(props: IconProps) {
  const id = useId();
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g
        clipPath={`url(#${id}-a)`}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.28996 19.12c.4584 0 .83-.3716.83-.83s-.3716-.83-.83-.83-.83.3716-.83.83.3716.83.83.83ZM16.4599 19.12c.4584 0 .83-.3716.83-.83s-.3716-.83-.83-.83-.83.3716-.83.83.3716.83.83.83ZM.620117 1.62012H3.95012l2.23 11.15998c.16.79.86 1.36 1.67 1.34h8.09998c.81.02 1.51-.55 1.67-1.34l1.33-6.98998H4.79012" />
      </g>
      <defs>
        <clipPath id={`${id}-a`}>
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </Icon>
  );
}
